import { PremiseOnSinglePremise } from 'app/premises/Premise';
import { useTranslation } from 'common/hooks/useTranslation';
import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { FormControl, Grid, MenuItem, TextField } from '@mui/material';

import { ODFContactTypes } from 'app/areas/ODFContactTypes';
import { Outlet } from '../../Outlet';
import { styles } from './OutletContactType.styles';
import { usePatchOutlet } from '../../hooks/usePatchOutlet';

export const OutletContactType: FC<{
  outlet: Outlet;
  premise: PremiseOnSinglePremise;
}> = ({ outlet, premise }) => {
  const { t } = useTranslation();
  const [outletContactType, setOutletContactType] = useState(outlet.contactType);

  const { mutate, isLoading } = usePatchOutlet(premise.propertyId, {
    onSuccess: () => {
      toast.success(t('general.updatedSuccessfully'));
    },
    onError: () => {
      toast.error(t('error.generalMessage'));
    },
  });

  useEffect(() => {
    if (outletContactType !== outlet.contactType) {
      mutate({ id: outlet.id, location: outlet.location ?? '', contactType: outletContactType as string });
    }
  }, [outletContactType]);

  return (
    <Grid container sx={styles.locationContainer}>
      <FormControl fullWidth>
        <TextField
          select
          disabled={isLoading}
          fullWidth
          label={t('areas.odf.contactType')}
          variant="outlined"
          value={outletContactType}
          onChange={(e) => setOutletContactType(e.target.value)}
        >
          {Object.values(ODFContactTypes).map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
    </Grid>
  );
};
